export const apiOriginUrl: string = 'https://api.v2.amitel.eu';
export const ceriServerUrl: string = 'https://api.amitel.eu:2323/api_amitel/';

export const environment = {
  production: true,
  sendTo: 'info@amitel.eu',
  local: '/assets/data',
  origin: `${apiOriginUrl}`,
  apiV1: '/api/v1/',
  service: {
    core: '/bff/service-core'
  },
  ceriServerUrl,
  auth0: {
    domain: 'https://amitel-production.eu.auth0.com',
    clientId: 'AQcvZBP4XdHj3Zh3RgG4aEYGFe75kPp7',
    audience: 'https://api.v2.amitel.eu'
  },
};
